import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { textLink } from '../../../styled/mixins';
import GlobalTheme from '../../../styled/GlobalTheme';

const Container = styled.div`
  display: flex;
  margin: 40px 0;
  align-items: center;
  flex-direction: column;

`;

const TextLink = styled.a`
  ${textLink}
  font-size: 12px;
  color: ${({ theme }) => theme.colors.white};
  font-weight: bold;
  ${GlobalTheme.breakpoints.up('sm')}{
    font-size: 16px;
  }
`;

const SignUpBox = () => (
  <Container>
    <TextLink href="/create-account-app">
      <FormattedMessage
        id="login.signup.link.app"
        defaultMessage="DON’T HAVE AN ACCOUNT?"
      />
    </TextLink>
  </Container>
);

export default SignUpBox;
